import React from 'react';

const TableRowManual = ({ children, className = '' }) => {
    return <tr className={className}>{children}</tr>;
};

export default TableRowManual;
